export type SortColumn<K> = {
  readonly columnKey: K;
  readonly direction: "ASC" | "DESC";
};

export function sortByKeys<T, K>(
  rows: T[],
  sortColumns: readonly SortColumn<K>[],
  comparatorProvider: (columnKey: K) => (a: T, b: T) => number,
): readonly T[] {
  return [...rows].sort((a, b) => {
    for (const sortColumn of sortColumns) {
      const comparator = comparatorProvider(sortColumn.columnKey);
      const compResult = comparator(a, b);
      if (compResult !== 0) {
        return sortColumn.direction === "ASC" ? compResult : -compResult;
      }
    }
    return 0;
  });
}
